import { EuiButtonEmpty } from "@inscopix/ideas-eui";
import { colGroupDefExecution, DataTableRowData } from "../DataTable";
import { GridApi } from "ag-grid-community";

export interface DataTableContentProps {
  gridApi: GridApi<DataTableRowData> | undefined;
  tableKind: "analysis" | "workflow";
}
export const QuickActionGoToTaskInfo = ({
  gridApi,
  tableKind,
}: DataTableContentProps) => {
  const handleClick = () => {
    const columnIds =
      gridApi
        ?.getProvidedColumnGroup(colGroupDefExecution(tableKind).groupId)
        ?.getChildren()
        .map((column) => column.getId()) ?? [];

    if (columnIds.length > 0 && gridApi !== undefined) {
      gridApi.ensureColumnVisible(columnIds[0], "start");
      // https://github.com/ag-grid/ag-grid/issues/5085
      setTimeout(() => {
        gridApi.flashCells({ columns: columnIds });
      }, 0);
    }
  };

  return (
    <EuiButtonEmpty
      size="xs"
      iconType="arrowEnd"
      iconSide="right"
      onClick={() => void handleClick()}
    >
      Go to {tableKind === "analysis" ? "task" : "run"} info
    </EuiButtonEmpty>
  );
};
